// extracted by mini-css-extract-plugin
module.exports = {"root":"YotpoReviewStars_root__IQnyo"};